import { Element } from "../Element.mjs";
import { isNonEmptyString } from "../validation/index.mjs";
export var VariableNode;

(function (VariableNode) {
  VariableNode.TYPE = 'variable';
  /**
   * @deprecated
   */

  VariableNode.BACKWARD_COMPATIBLE_TYPE = 'placeholder';

  function isVariableNode(value) {
    return Element.isElement(value, VariableNode.TYPE) || Element.isElement(value, VariableNode.BACKWARD_COMPATIBLE_TYPE);
  }

  VariableNode.isVariableNode = isVariableNode;

  function validateVariableNode(value) {
    var isValidKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isNonEmptyString;
    var isValid = isVariableNode(value) && typeof value.key === 'string' && isValidKey(value.key);
    return isValid ? value : null;
  }

  VariableNode.validateVariableNode = validateVariableNode;
})(VariableNode || (VariableNode = {}));